import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "学习轨迹",
  "lead": "虽然现在大多数儿童都会在学校学习很多年，但他们往往连最基本的阅读和数学技能都没有掌握。学习轨迹显示了儿童在学校成长过程中所学到的东西。它们可以帮助我们了解导致学习成果低下的过程、何时以及如何在该过程中进行干预，还能模拟不同政策对学习水平低下这一紧迫挑战可能产生的影响。"
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Explorer, Figure, HighlightByIndex, IndicatorReference, RelatedMaterial, ScrollyArea, ScrollySection, ScrollyStep, ScrollySticky, SimulationsTab, TrajectoriesTab} = _components;
  if (!Explorer) _missingMdxReference("Explorer", true);
  if (!Figure) _missingMdxReference("Figure", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollyStep) _missingMdxReference("ScrollyStep", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  if (!SimulationsTab) _missingMdxReference("SimulationsTab", true);
  if (!TrajectoriesTab) _missingMdxReference("TrajectoriesTab", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_LEARNING"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "学习轨迹显示了儿童掌握基础技能所需的学习年数或需要达到的年级水平。由于这些轨迹可以跟踪系统中的学习进度，因此可以帮助我们了解有多少儿童难以掌握这些技能，何时和如何进行干预，以及不同的政策可能会对学习水平低下这一紧迫挑战产生的影响。"
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      id: "学习轨迹能告诉我们什么",
      children: "学习轨迹能告诉我们什么？"
    }), "\n", _jsx(_components.p, {
      children: "理想情况下，学习轨迹是陡峭的。但是，我们经常会看到平缓的学习轨迹，这表明学习进度缓慢。起步缓慢可能会产生长期后果。这是因为当孩子学习落后时，课程通常会向前推进至更高级别的内容，而他们缺乏必要的技能来跟上进度。"
    }), "\n", _jsx(_components.p, {
      children: "**许多国家的学习轨迹表明，学习进度过于缓慢，而这一问题从入学开始就已显现。**在一年级和二年级，全球目标和许多国家的课程都假定孩子们正在学习阅读，但实际上只有一小部分孩子真正实现了这一目标。"
    }), "\n", _jsx(IndicatorReference, {
      id: "4.1.1",
      label: "4.1.1a",
      children: _jsxs(_components.p, {
        children: ["第六轮 UNICEF 多指标类集调查 (MICS6) 对这些技能进行了衡量，它们是未来学习不可或缺的基石。此处则通过评估孩子们能否大声朗读一篇 70 字的简短故事（如“Manh 在二班。”）并回答有关该故事的五个简单问题（如“Manh 在哪个班？”）来进行衡量。这些基本技能通常低于", _jsx(_components.a, {
          href: "https://sdgs.un.org/goals/goal4",
          children: "可持续发展目标 (SDG) 全球指标 4.1.1 a"
        }), " 定义的最低能力水平。因此，对于 SDG 4.1.1 a 而言，尽管计算出的轨迹可能高估了进展，但仍然是能反映学习进度的有效估算。"]
      })
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "TRAJECTORIES_CURRENT"
        })
      }), _jsx(ScrollySection, {
        id: "HIGHLIGHT_VIETNAM",
        children: _jsxs(_components.p, {
          children: [_jsx(HighlightByIndex, {
            index: "2",
            children: "越南"
          }), "就是一个\n学习轨迹表现相对优异的典范。在学校的初始年级\n阶段，越南的大多数儿童会学习基本的阅读技能。"]
        })
      }), _jsx(ScrollySection, {
        id: "LMIC_GRADE_3",
        children: _jsxs(_components.p, {
          children: ["许多其他", " ", "\n", _jsx(HighlightByIndex, {
            index: "4",
            children: "低收入和中低收入"
          }), " ", "\n国家的学习轨迹则要平缓得多。目前，在平均水平的国家中，只有四分之一的儿童\n会在 3 年级时学习基本的阅读技能。"]
        })
      }), _jsx(ScrollySection, {
        id: "LMIC_GRADE_6",
        children: _jsxs(_components.p, {
          children: ["随着学习进程的推进，学习水平低下的问题仍然存在。在数据集中，\n处于平均水平的", " ", "\n", _jsx(HighlightByIndex, {
            index: "4",
            children: "低收入和中低收入"
          }), " ", "\n国家的六年级学生中，仅有略多于一半的学生掌握了通常是二年级或三年级水平的阅读\n技能。"]
        })
      }), _jsx(ScrollySection, {
        id: "DIFFERENCE_TRAJECTORIES",
        children: _jsx(_components.p, {
          children: "但是，平均轨迹掩盖了各国之间的差异。在数据集中的\n低收入和中低收入国家中，有 3% 至 76% 不等的儿童\n在三年级时能够阅读。这\n表明，即便在国民收入相对较低的国家，只要致力于\n改善基础学习，就能取得进展。"
        })
      }), _jsx(ScrollyStep, {
        id: "default"
      })]
    }), "\n", _jsx(_components.p, {
      children: "对于想要解决学习水平低下这一问题的国家来说，政策要点包括："
    }), "\n", _jsx(_components.p, {
      children: "-从低年级开始，衡量并优先重视基础技能。\n-保持教学与儿童的实际学习节奏步调一致。这可以通过多种方式来实现，包括设定以基础学习为重点的明确学习目标，调整课程进度以及协助教师了解和调整教学以适应儿童当前的学习水平。"
    }), "\n", _jsx(_components.h2, {
      id: "政策模拟入学机会和学习水平",
      children: "政策模拟：入学机会和学习水平"
    }), "\n", _jsx(_components.p, {
      children: "我们可以利用学习轨迹来比较不同政策带来的潜在影响。在这里，我们模拟了旨在增加入学机会和增强学习水平的政策的影响。以入学机会为导向的政策旨在增加儿童的在校年限。这些政策包括免费中小学教育、学校建设、自动升级以及其他主要侧重于入学率或学业完成度的政策。以学习水平为导向的政策旨在提高儿童在学校每个年级的学习成果。这些政策的例子包括根据明确的学习目标设定和衡量进度，调整教学以适应儿童的学习进度，以及支持有效的教学。"
    }), "\n", _jsxs(_components.p, {
      children: ["每个儿童都应当有上学的机会，让孩子上学是实现全民教育必要的第一步。但是，这些模拟结果表明，进一步", _jsx(HighlightByIndex, {
        index: "2",
        children: "增加入学机会"
      }), "本身对于解决学习问题来说几乎无济于事。相比之下，", _jsx(HighlightByIndex, {
        index: "3",
        children: "提高各年级的学习水平"
      }), "以赶上表现优异的低收入和中低收入国家的步伐，可以带来巨大的潜在收益。"]
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "TRAJECTORIES_SIMULATION_LMIC"
        })
      }), _jsx(ScrollySection, {
        id: "COMPARISON",
        children: _jsx(_components.p, {
          children: "表现较差和表现较好的国家之间的表现差异\n既源于提供更多的入学机会，也尤其源于\n让儿童在每个年级都能学到更多的知识。"
        })
      }), _jsx(ScrollySection, {
        id: "FADED",
        children: _jsx(_components.p, {
          children: "这些模拟结果显示了按年龄划分的学习轨迹。它们既涵盖了在校儿童，\n也包括了失学儿童。由于失学儿童的学习成就\n往往偏低，这些学习轨迹较按年级划分的学习轨迹更为平缓。"
        })
      }), _jsx(ScrollySection, {
        id: "CURRENT",
        children: _jsxs(_components.p, {
          children: ["从五个表现不佳的", " ", "\n", _jsx(HighlightByIndex, {
            index: "4",
            children: "低收入和中低收入"
          }), " ", "\n国家的平均情况来看，只有 8% 的 9 岁儿童能够达到与年龄适宜的阅读\n水平。"]
        })
      }), _jsx(ScrollySection, {
        id: "SIMULATION_ACCESS",
        children: _jsxs(_components.p, {
          children: [_jsx(HighlightByIndex, {
            index: "2",
            children: "入学机会模拟"
          }), " ", "\n估算了如果所有孩子均入学可能会发生的情况。这是通过\n估算当所有从未上过学\n或辍学的儿童能够达与同龄在校学生相同的平均年级\n和学习水平时会发生的情况来实现的。在相同的五个\n表现不佳的国家中，模拟结果表明，这将使\n能够阅读的 9 岁儿童比例增加 1 个百分点。"]
        })
      }), _jsx(ScrollySection, {
        id: "SIMULATION_LEARNING",
        children: _jsxs(_components.p, {
          children: ["如果这些国家中的 9 岁儿童继续维持在\n现有的年级水平，但取而代之的是，将", " ", "\n", _jsx(HighlightByIndex, {
            index: "3",
            children: "各年级的学习进度"
          }), "提升至\n与五个表现最佳的低收入和中低收入国家的儿童相当的水平，\n那么这些儿童中可能将有 43% 能够阅读 — 增长了\n35 个百分点。"]
        })
      }), _jsx(ScrollyStep, {
        id: "default"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "策略模拟平等性",
      children: "策略模拟：平等性"
    }), "\n", _jsx(_components.p, {
      children: "学习轨迹也是了解国内群体间学习差异的有力工具。在这里，我们对比了富有和贫穷群体的学习情况，并模拟了旨在减少二者之间不平等的政策的影响。"
    }), "\n", _jsxs(_components.p, {
      children: ["从数据集中所有低收入和中低收入国家的平均情况来看，相较于贫穷家庭（家庭财富位于后 20％）儿童，富有家庭（家庭财富位于前 20％）儿童的在校时间更长，且在各年级所学知识也更多。", _jsx(HighlightByIndex, {
        index: "2",
        children: "平等入学机会模拟"
      }), "显示的是当穷人与富人的受教育年限相等时可能会发生的情况，而", _jsx(HighlightByIndex, {
        index: "3",
        children: "平等学习水平模拟"
      }), "则显示的是当穷人与富人在各年级的学习进度相同时可能会发生的情况。在这两种情况下，尤其是在平等学习水平模拟中，不平等现象都会有所降低。"]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.strong, {
        children: "但是，即便是富人的孩子，所接受的教育也并不算很好。"
      }), "。将近一半的富人的孩子未能掌握基本的阅读技能，这限制了以公平为导向的政策可能带来的潜在影响。针对男女平等或城乡儿童平等的模拟，结果显示所带来的改善甚至更小。"]
    }), "\n", _jsxs(_components.p, {
      children: ["对于想要解决学习水平低下这一问题的国家来说，政策要点在于缩小国内群体之间的差距只是解决方案的一部分。", _jsx(_components.strong, {
        children: "同样紧迫的挑战是进行系统性变革，改善所有儿童（包括城乡地区的富人和穷人、男孩和女孩）的学习，以实现从低表现系统向高表现系统的过渡。"
      })]
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "TRAJECTORIES_SIMULATION_EQUALITY"
        })
      }), _jsx(ScrollySection, {
        id: "CURRENT",
        children: _jsxs(_components.p, {
          children: [_jsx(HighlightByIndex, {
            index: "4",
            children: "贫穷"
          }), "家庭儿童\n在学习轨迹上落后于富有家庭儿童。从\n23 个低收入和中低收入国家的平均情况来看，只有 19%\n来自贫穷家庭的儿童在 9 岁时具备了基本的阅读技能。"]
        })
      }), _jsx(ScrollySection, {
        id: "SIMULATION_ACCESS",
        children: _jsxs(_components.p, {
          children: [_jsx(HighlightByIndex, {
            index: "2",
            children: "第一个模拟"
          }), "显示的是\n当贫穷家庭儿童与富有家庭儿童\n的受教育年限相等时（以年龄对应的年级水平来衡量）可能会发生的情况。从\n23 个国家的平均情况来看，这仅会将 9 岁时的基础阅读技能提高 4\n个百分点。"]
        })
      }), _jsx(ScrollySection, {
        id: "SIMULATION_LEARNING",
        children: _jsxs(_components.p, {
          children: [_jsx(HighlightByIndex, {
            index: "3",
            children: "第二个模拟"
          }), "显示的是\n当贫穷家庭儿童维持现有\n教育水平（即达到现在相同的年级水平），但\n各年级学习进度提升至与富有家庭儿童相同的水平时，可能会发生的情况。这可能会将\n9 岁时的基础阅读技能提高 17 个百分点\n。"]
        })
      }), _jsx(ScrollySection, {
        id: "COMPARISON",
        children: _jsx(_components.p, {
          children: "如果贫穷家庭儿童与富有家庭儿童的受教育年限相等且\n学习进度相同时（即穷人与富人的学习轨迹相同），\n贫穷家庭儿童 9 岁时的基础阅读技能可能会提高 29\n个百分点。"
        })
      }), _jsx(ScrollySection, {
        id: "COMPARISON_GROUP",
        children: _jsx(_components.p, {
          children: "但是，这样仍然会有近一半的孩子未能掌握基础\n阅读技能。在许多国家，即便是富有家庭儿童，也未能接受到\n良好的教育。"
        })
      }), _jsx(ScrollyStep, {
        id: "default"
      })]
    }), "\n", _jsx(_components.h2, {
      id: "创建自己的学习轨迹和政策模拟",
      children: "创建自己的学习轨迹和政策模拟"
    }), "\n", _jsx(_components.p, {
      children: "以下工具可用于创建学习轨迹和进行政策模拟。您可以浏览多个国家的基础阅读和数学技能相关数据。"
    }), "\n", _jsxs(_components.p, {
      children: ["提醒一下，阅读技能的衡量标准是孩子能否大声朗读一篇 70 字的简短故事，并回答有关该故事的五个简单问题。数学技能的衡量涵盖四个领域（数字识别、数字辨别、简单加法和数字模式），包含 21 个简单问题。如果孩子正确回答了所有问题，则会被视为已经掌握了这些基本的阅读和数学技能。这些技能通常是二年级或三年级水平，低于", _jsx(_components.a, {
        href: "https://sdgs.un.org/goals/goal4",
        children: "SDG 全球指标 4.1.1a"
      }), "定义的最低能力水平。"]
    }), "\n", _jsxs(Explorer, {
      children: [_jsx(TrajectoriesTab, {
        children: _jsx(_components.p, {
          children: "学习轨迹在不同背景下差异很大。借助这个工具，您可以\n构建、比较和导出最相关的轨迹。\n您可以可视化和比较不同国家的轨迹，或者\n构建和比较同一国家内部不同群体的轨迹。"
        })
      }), _jsx(SimulationsTab, {
        children: _jsx(_components.p, {
          children: "这些工具可以协助您进行策略模拟并分析结果，为\n政策优先事项提供参考。您可以在国家层面进行政策模拟\n，估算实现普及教育\n以及达到与对比国家各年级相同的学习进度会产生的影响。您还可以\n针对同一国家内部的不同群体进行政策模拟，\n模拟当两个群体的\n受教育程度和学习水平相同时会产生的影响。"
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "结语",
      children: "结语"
    }), "\n", _jsx(_components.p, {
      children: "学习轨迹揭示了儿童掌握基础学习技能的速度。它们是重要的工具，可用于提升公众对学习成果低下的认知，并帮助决策者制定行动计划。"
    }), "\n", _jsx(_components.h3, {
      id: "致谢",
      children: "致谢"
    }), "\n", _jsxs(_components.p, {
      children: ["本网页的内容由 ", _jsx(_components.a, {
        href: "http://riseprogramme.org/",
        children: "RISE（教育体系改善研究）计划"
      }), " 创建，这是一项大型教育系统研究计划，由", _jsx(_components.a, {
        href: "https://www.gov.uk/government/organisations/foreign-commonwealth-development-office",
        children: "英国外交、联邦和发展事务部 (FCDO)"
      }), "、", _jsx(_components.a, {
        href: "http://dfat.gov.au",
        children: "澳大利亚政府外交贸易部 (DFAT)"
      }), " 和", _jsx(_components.a, {
        href: "https://www.gatesfoundation.org",
        children: "比尔及梅琳达·盖茨基金会"
      }), " 提供资助。该计划由", _jsx(_components.a, {
        href: "https://www.opml.co.uk",
        children: "牛津政策管理 (Oxford Policy Management)"
      }), " 和[牛津大学布拉瓦尼克政治学院] (http://bsg.ox.ac.uk) 合作进行管理和实施。"]
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://riseprogramme.org/tools/learning-trajectories",
            children: "学习轨迹资源 — RISE"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://data.unicef.org/resources/are-children-really-learning-foundational-skills-report/",
            children: "孩子们真的在学习吗？在学习危机中探索基础技能 — UNICEF 2022"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.sciencedirect.com/journal/international-journal-of-educational-development/special-issue/1035CNWP9N3",
            children: "学习概况特刊（开源） — 《国际教育发展杂志》 (IJED)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://mics.unicef.org/files?job=W1siZiIsIjIwMjAvMDUvMTIvMTgvMjUvNDUvNzAxLzIwXzA1XzA4X01JQ1NfR3VpZGVib29rX2NvbXByZXNzZWQucGRmIl1d&sha=6d386818d588d05c",
            children: "如何分析 MICS6 教育数据 — UNICEF"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://riseprogramme.org/publications/descriptive-learning-trajectories-and-policy-simulations-using-mics6-data",
            children: "模拟方法论 — RISE"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
